export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		PATIENT: 4
	},
	USER: {
		VERIFIED: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
		STATUS: {
			PENDING: 0,
			ACTIVE: 1,
			INACTIVE: 2,
		}
	},
	USER_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	MODULES: {
	    USERS: 1,
	    SAN: 2,
	    POSITIONS: 3,
	    PAYMENTS: 4,
	    REPORTS: 5,
	    COMMISSIONS: 6,
	    ACCREDITATIONS: 7,
	    NOTIFICATIONS: 8,
	    STRUCTURE: 9,
	    MODERATORS: 10,
	    COLLECTIONS: 11,
	    REMINDERS: 12,
	    SURVEYS: 13,
	    MISSIONS: 14,
	    REFERRALS: 15,
	    CHATS: 16,
	    ADVERTISEMENTS: 17
	},
	FREQUENCIES: {
		WEEK: 1,
		MONTH: 2,
		BIWEEK: 3
	},
	DOCUMENT_TYPES: {
		V: 1,
		E: 2,
		G: 3,
		J: 4,
		PASSPORT: 5,
		COLOMBIA: 6
	},
	VERIFIED_STATUS: {
	    PENDING: 0,
	    VERIFIED: 1,
	    REJECTED: 2
	},
	STATUS_PAYMENT: {
		PENDING: 1,
		IN_PROGRESS: 2,
		FINISH: 3,
		CANCELLED: 4
	},
	IMPORTANT_POSITIONS: [1,2,3],
	GLOBAL_NOTIFICATION_TYPES: {
		ALL: 1,
		INACTIVE: 2,
		ACTIVE: 3,
		SAN: 4,
		DUE_1: 5,
    	DUE_2: 6,
    	ACCREDITED: 7,
	    NO_ACCREDITED: 8,
	    USERS_WITHOUT_SAN: 9
	},
	MESSAGE_BOT: {
	    YES: 1,
	    NO: 0
	},
	SAN_TYPES: {
	    PREMIUM: 1,
	    BASIC: 2
	},
	GLOBAL_NOTIFICATION_WAYS: {
		PUSH: 1,
		SMS: 2,
		BOTH: 3,
		CHAT: 4
	},
	AUTOACCREDITATIONS: {
	    YES: 1,
	    NO: 0
		},
	INCLUDE_ALT_PHONE: {
		YES: 1,
		NO: 0,
	},
	REMINDER_TYPES: {
	    USERS_WITH_DUES: 1,
	    USERS_WITHOUT_SAN: 2,
	    USERS_WITH_SAN: 3,
	    ACCREDITED: 4,
	    NO_ACCREDITED: 5,
	    ALL: 6,
	    INACTIVE: 7,
	    ACTIVE: 8,
	    DUE_1: 9,
	    DUE_2: 10
	},
	REMINDER_CHANNELS: {
		PUSH: 1,
		SMS: 2,
		BOTH: 3,
		CHAT: 4
	},
	REMINDER_MODES: {
		DAYS: 1,
		DATE: 2
	},
	ACCREDITED:  {
    	YES: 1,
    	NO: 0
    },
    REMINDER_ACCREDITED: {
    	ALL: 0,
    	YES: 1,
    	NO: 2
    },
    FAIL_ACCREDITATION: {
		YES: 1,
		NO: 0
	},
	SURVEY_STATUS: {
		ONGOING: 1,
		FINISH: 0,
		ACTIVE: 1,
		INACTIVE: 0
	},
	MISSION_TYPES: {
	    DAYS_BEFORE: 1,
	    DAY: 2
	},
	MISSION_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	REFERRAL_STATUS: {
	    PENDING: 1,
	    FINISH: 2,
	    PAID: 3
	},
	SAN_MODALITIES: {
	    CLASSIC: 1,
	    NEW_MODEL: 2
	},
	CLAIM_STATUS: {
	    ACTIVE: 1,
	    FINISH: 2
	},
	PAYMENT_METHODS: {
	    BINANCE: 1,
	    PAGO_FLASH: 2,
	    CHINCHIN: 3,
	    BNC: 4,
	    DIRECT: 5,
	    MANUAL: 6,
	    R4: 7
	},
	TEMPORAL_PAYMENT_STATUS: {
	    ACTIVE: 1,
	    INACTIVE: 0,
	    REFUND: 2
	},
	POINT_LEVELS: {
	    BRONZE: 1,
	    SILVER: 2,
	    GOLD: 3,
	    DIAMOND: 4
	},
	CHINCHIN_VERIFIED: {
		YES: 1,
		NO: 0
	},
	COUNTRIES: {
		VZLA: 1,
		COL: 2
	},
	CURRENCIES: {
		USD: 1,
		EUR: 2,
		COP: 3
	},
	CURRENCY_SYMBOL: {
		USD: '$',
		EUR: '€',
		COP: '$'
	},
	BANK_ACCOUNT_TYPES: {
		SAVINGS: 1,
		CHECKING: 2
	},
	ADVERTISEMENTS_STATUS: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	BANK_DATA_TYPE: {
	    TRANSFER: 1,
	    BRE_B: 2
	}
}